import { pushUnsafe, replaceUnsafe } from "@swan-io/chicane";
import { useEffect } from "react";

type Props = {
  to: string;
  replace?: boolean;
};

export const Redirect: React.FC<Props> = ({ to, replace = false }) => {
  useEffect(() => {
    const isExternal = to.startsWith("http");

    if (isExternal) {
      window.location.href = to;
      return;
    }

    if (replace) {
      replaceUnsafe(to);
    } else {
      pushUnsafe(to);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};
